// 编辑部内容数据 - 大瓜观察局
// 说明：本文件内容为行业现象观察与媒体分析，不针对现实具体人物进行不实指控。

export const siteNav = [
  { id: "radar", label: "热点雷达" },
  { id: "columns", label: "内幕栏目" },
  { id: "deep", label: "深读专栏" },
  { id: "faq", label: "用户问答" },
  { id: "about", label: "编辑部" },
];

export const hotRadar = [
  { tag: "台本疑云", title: "选秀「逆袭剧本」为何总是那几条线？拆解人设翻红的通用模板", heat: 92 },
  { tag: "剪辑黑幕", title: "一句慢反应被放大成「怼导师」，花字与配乐如何重塑真实情绪", heat: 88 },
  { tag: "选手风波", title: "旧照旧言被考古，选手过往言行为何总在播出期间集中引爆", heat: 84 },
  { tag: "导师争议", title: "点评被断章取义？嘉宾原话与播出内容之间的信息差从何而来", heat: 79 },
  { tag: "台本疑云", title: "台本到底写到哪一层？关于真人秀「剧情指导」的四种常见边界", heat: 75 },
  { tag: "剪辑黑幕", title: "镜头越多越「皇族」？镜头量与最终名次的统计观察", heat: 71 },
];

export const columns = [
  {
    id: "script",
    icon: "ri-file-user-line",
    name: "台本疑云",
    slogan: "真人秀真的没有剧本吗",
    desc: "盘点选秀与竞技真人秀中的「剧情指导」「人设走向」与逆袭模板，厘清台本工业的常见边界。",
    count: "86 篇深度内容",
    theme: "bg-ember-700",
  },
  {
    id: "edit",
    icon: "ri-movie-2-line",
    name: "剪辑魔法",
    slogan: "镜头之外的另一种真实",
    desc: "从花字、配乐、慢动作到导师反应镜头，分析剪辑如何在几十小时素材里塑造叙事与情绪。",
    count: "64 篇深度内容",
    theme: "bg-ink-800",
  },
  {
    id: "talent",
    icon: "ri-vip-crown-line",
    name: "选手风波",
    slogan: "人设立起与坍塌的瞬间",
    desc: "复盘选秀期间被集中讨论的选手言行、过往考古与舆论反转，讨论人设管理与风险边界。",
    count: "51 篇深度内容",
    theme: "bg-amberstone-600",
  },
  {
    id: "mentor",
    icon: "ri-mic-line",
    name: "导师争议",
    slogan: "当点评成为节目的一部分",
    desc: "探讨导师点评尺度、断章取义与剪辑放大的关系，梳理嘉宾争议背后的传播链条。",
    count: "43 篇深度内容",
    theme: "bg-ember-800",
  },
];

export const deepReads = [
  {
    col: "台本疑云",
    date: "2026-08-29",
    read: "11 分钟",
    badge: "行业科普",
    title: "从「上帝视角」到「陪跑叙事」：竞技真人秀剧情指导的真实边界",
    excerpt:
      "「有台本」常被观众当成一句玩笑，但真人秀的录制与呈现之间确实存在一整套流程约定。本文尝试从行业通行的操作说起，区分『规则剧本』与『人设剧本』的差别。",
  },
  {
    col: "剪辑魔法",
    date: "2026-08-22",
    read: "9 分钟",
    badge: "镜头拆解",
    title: "一句话如何被剪成三种意思：反应镜头、BGM 与叙事节奏的作用机制",
    excerpt:
      "同样的素材，配乐与节奏一变，情绪就完全不同。我们拆解一段典型片段的后期流程，聊聊『慢放』『定格』与『寂静时刻』如何制造观众的情绪落点。",
  },
  {
    col: "选手风波",
    date: "2026-08-15",
    read: "8 分钟",
    badge: "现象复盘",
    title: "考古风暴为何总在播出期？平台、粉丝与舆论的三方共振",
    excerpt:
      "当一位选手热度上升，过往言论常被成体系地翻出。本文从传播角度讨论『考古』的时间节点、推动者与传播半径，帮助读者更理性看待片段化信息。",
  },
  {
    col: "导师争议",
    date: "2026-08-07",
    read: "7 分钟",
    badge: "立场辨析",
    title: "导师点评被放大之后：断章、完整语境与节目组的选择性取舍",
    excerpt:
      "一个被热议的点评，往往只是长对话中的一个切片。全文语境对理解言论至关重要，本片梳理『切片传播』的常见路径与信息损耗。",
  },
  {
    col: "台本疑云",
    date: "2026-07-30",
    read: "10 分钟",
    badge: "深度盘点",
    title: "真人秀里被反复使用的五种叙事模板：逆袭、虐粉、复活与意难平",
    excerpt:
      "爆款选秀为何总有一种『熟悉的配方』？我们梳理被反复验证的叙事结构，讨论它们如何高效调动观众情绪，也提醒别把结构当成全部真相。",
  },
  {
    col: "剪辑魔法",
    date: "2026-07-21",
    read: "6 分钟",
    badge: "视角透视",
    title: "镜头量能说明什么？关于『皇族』说法的数据与反例",
    excerpt:
      "「谁镜头多谁是皇族」是弹幕常见判断，但镜头量的统计口径、背后剪辑逻辑都值得拆开看。本文用多期观察给出另一种视角。",
  },
  {
    col: "选手风波",
    date: "2026-07-12",
    read: "9 分钟",
    badge: "人设观察",
    title: "从初舞台到成团夜：选手人设管理的四个阶段与翻车临界点",
    excerpt:
      "每个出道选手几乎都要经历立人设、强化人设与可能的反噬。我们梳理人设运行的一般周期，以及它为何在某些节点容易失效。",
  },
  {
    col: "导师争议",
    date: "2026-07-03",
    read: "8 分钟",
    badge: "媒体观察",
    title: "嘉宾热度是把双刃剑：节目邀约、话题预埋与『争议流量』经济学",
    excerpt:
      "争议是天然的话题引擎，但过度消费也会伤及嘉宾与节目口碑。本文从内容平台的内容运营角度，聊一聊『争议流量』的取舍。",
  },
];

export const faqs = [
  {
    q: "综艺真的都有台本吗？",
    a: "「台本」在行业里有不同含义。多数真人秀并不存在逐字逐句的对白稿，但会通过赛制规则、环节设置、流程脚本来规划大致走向；部分竞技类节目为戏剧张力，会提前设计『剧情弧线』。观众应区分『规则框架』与『逐字剧本』，不要简单用『全都有剧本』否定一切，也不应完全排除存在剧情引导的可能。",
  },
  {
    q: "剪辑真的能改变一个人说的话吗？",
    a: "剪辑可以改变叙事的情绪与语境。通过调整反应镜头、背景音乐、插入顺序，同一句原话可能被赋予截然不同的含义，也就是常说的『断章取义』。这也是『剪出对立』这类吐槽的由来。观看争议片段时，建议寻找完整原始素材再做判断。",
  },
  {
    q: "为什么选手的黑料总在热度最高时被曝出？",
    a: "这背后是多方共振：热度上升后，过往社交平台内容会被成体系考古，同时营销号与对家粉丝也会加速传播，平台算法又偏爱冲突话题。时点集中并非单一原因所致，但确实与传播规律高度相关。",
  },
  {
    q: "本站的内容是真实的『内幕爆料』吗？",
    a: "不是。大瓜观察局定位为行业现象观察与媒体分析媒体，所有内容都基于公开信息、行业常识与传播学规律撰写，探讨的是『现象如何发生』『我们如何理性看待』，不针对现实具体人物发布未经证实的信息或人格贬损内容。",
  },
  {
    q: "导师的争议点评应该如何理性看待？",
    a: "建议先把争论的原话放回完整语境：它出现在怎样的讨论环节、前后是否有剪辑、现场氛围如何。其次区分『专业批评』与『人身攻击』，也不要让只言片语的切片代替对嘉宾的整体判断。",
  },
  {
    q: "我想投稿或提供线索，应该怎么联系？",
    a: "欢迎通过页面底部『投稿反馈』表单与我们联系。出于内容与法律审慎，涉及具体人物的未经核实信息本站不采信、不发布，我们更欢迎关于行业现象、剪辑手法、传播规律等可验证主题的来稿与讨论。",
  },
];